<template>
  <el-dialog
    width="900px"
    custom-class="import-dialog"
    title="添加商品"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <el-select
            clearable
            class="mr10"
            size="small"
            filterable
            v-model="searchCondition.gameType"
            visible-change="otherActivity"
            placeholder="请选择活动类型"
        >
          <el-option
              :label="v.gameName"
              :value="v.gameCode"
              :key="i"
              v-for="(v, i) in gameTypeList"
          ></el-option>
        </el-select>


          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchCondition.keyWords"
            placeholder="请输入名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          ref="brandTable"
          :highlight-current-row="radio"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
          :data="microShopGoodsList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column v-if="!radio" type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
         
         

          <el-table-column
            header-align="center"
            align="center"
            label="活动类型"
            prop="gameType"
          >
            <template slot-scope="scope">
              {{ scope.row.gameType === "turntable" ? "大转盘" : "" }}
              {{ scope.row.gameType === "seckill" ? "秒杀" : "" }}
              {{ scope.row.gameType === "bargain" ? "砍价" : "" }}
              {{ scope.row.gameType === "bargains_team" ? "特价团" : "" }}
              {{ scope.row.gameType === "lottery_team" ? "抽奖团" : "" }}
              {{ scope.row.gameType === "collect_card" ? "集卡" : "" }}
              {{ scope.row.gameType === "leader_free_team" ? "团长免单团" : "" }}
              {{ scope.row.gameType === "integral_exchange" ? "积分兑换" : "" }}
              {{ scope.row.gameType === "single_single_exclusive" ? "单人单次专享" : ""}}
              {{ scope.row.gameType === "lucky_charm" ? "锦鲤活动" : "" }}
              {{ scope.row.gameType === "combination_set" ? "组合套餐活动" : "" }}
              {{ scope.row.gameType === "help_coupon" ? "助力劵" : "" }}
              {{ scope.row.gameType === "save_money_card" ? "省钱卡" : "" }}
              {{ scope.row.gameType === "password" ? "口令红包" : "" }}
              {{ scope.row.gameType === "red_envelope_rain" ? "红包雨" : "" }}
              {{ scope.row.gameType === "jielong" ? "接龙" : "" }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="gameName"
            label="活动名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
            width="150"
          ></el-table-column>
          <el-table-column
            width="280"
            header-align="center"
            align="center"
            prop="createTime"
            label="活动时间"
          >
            <template slot-scope="scope">
              {{ scope.row.gameStartTime }}至{{ scope.row.gameEndTime }}
            </template>
          </el-table-column>


        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="microShopGoodsList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="saveGoods"
          >确 定</el-button
        >
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      tHeader: [],
      tBody: [],
      gameTypeList:[],
      microShopGoodsList: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      checkedCurrentRow: {},
      batchCondition: {
        oldWord: "",
        newWord: "",
        wxshopCategoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: mapGetters([
    "salesChannels",
    "allMicroShopGoodsList",
    // "gameTypeList"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch("querySalesChannels");
    this.queryList();
    this.getGameTypeList();
  },
  methods: {
    async getGameTypeList(){
      const { result } = await this.$store.dispatch("queryGameTypeList");
      this.gameTypeList = result;
    },
    saveGoods() {
      // if (this.radio) {
      //   this.$emit("setLink", this.checkedCurrentRow);
      // } else {
      //   this.$emit("saveGoods", this.checkedRow);
      // }
      if (!this.checkedCurrentRow.gameId) {
        this.$message({
          type: "warning",
          message: "请先选择热销活动商品",
        });
      } else {
        let url = "";
        switch (this.checkedCurrentRow.gameType) {
          case 'turntable': //大转盘
            url = `/activity/turnTable/turnTable`
            break;
          case 'seckill': //秒杀
            url = `/activity/seckill/seckill?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'bargain': //砍价
            url = `/activity/bargain/bargain?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'collect_card': //集卡
            url = `/activity/collectCard/collectCard`
            break;  
          case 'integral_exchange': //单人单次专享
            url = `/activity/integral/integralIndex?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'single_single_exclusive': //积分兑换
            url= `/activity/single/singleActivityList?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'bargains_team': //特价团
            url= `/activity/groupBuying/groupBuying?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'lottery_team': //抽奖团
            url= `/activity/groupBuying/groupBuying?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'leader_free_team': //团长免单团
            url= `/activity/groupBuying/groupBuying?gameId=${this.checkedCurrentRow.gameId}`
            break;    
          case 'lucky_charm': //锦鲤活动
            url= `/activity/luckyOne/luckyOne?gameId=${this.checkedCurrentRow.gameId}&gameShareContent=${this.checkedCurrentRow.gameShareContent}`
            break;
          case 'combination_set': //组合套餐活动
            url= `/activity/shopList/index?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'help_coupon': //助力劵
            url= `/activity/powerStamps/powerStamps?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'save_money_card': //省钱卡
            url= `/activity/saveMoney/saveMoney?gameId=${this.checkedCurrentRow.gameId}`
            break;
          case 'password': //口令红包
            url= `/activity/passwordRedEnvelope/passwordRedEnvelope`
            break;  
          case 'red_envelope_rain': //红包雨
            url= `/activity/redEnvelopeRain/redEnvelopeRain`
            break;
          case 'jielong': //接龙
            url= `/activity/jieLong/infor?gameId=${this.checkedCurrentRow.gameId}`  
            break;
          default:
            break;
        }

        this.$emit("setLink", {url, gameName: this.checkedCurrentRow.gameName});
      }


      // this.$emit("setLink", this.checkedCurrentRow);
    },
    handleSelectionChange(row) {
      console.log(row);
      this.checkedRow = row;
    },
    handleCurrentChange(row) {
      console.log(row);
      this.checkedCurrentRow = row;
    },
    close() {
      this.$emit("close");
    },
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.wxshopCategoryId =
        batchCondition.wxshopCategoryId[
          batchCondition.wxshopCategoryId.length - 1
        ];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList(queryAll) {
      console.log('运行了吗');
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.searchCondition.keyWords,
        gameType: this.searchCondition.gameType,
        enabledState: "yes",
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.gameType = this.isArray(
        searchCondition.gameType
      )
        ? searchCondition.gameType[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.gameType;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      Object.assign(params, searchCondition);
      const actionName = "queryMyActivityList";
      
      
      const { result } = await this.$store.dispatch(actionName, params);

      console.log(result);
      this.microShopGoodsList = result.pageList;




    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
